// extracted by mini-css-extract-plugin
module.exports = {"root":"TemplateEditor_root__5kjNU"};